import { createAsyncThunk } from '@reduxjs/toolkit';
import { fbStore } from '../../utils/firebase';

export const getPhrases = createAsyncThunk(
  'phrase/getList',
  async (_, { rejectWithValue, getState }) => {
    try {
      const {
        phrase: { phrases },
      } = getState();
      const startDate = phrases.length ? phrases[0].createdAt : '2020-01-01T00:00:00.001Z';
      const queryBuilder = await fbStore
        .collection('phrases')
        .where('createdAt', '>', startDate)
        .orderBy('createdAt', 'desc');

      const newWords = await queryBuilder
        .get()
        .then((querySnapshot) =>
          querySnapshot.docs.map((item) => ({ ...item.data(), id: item.id })),
        );
      const updatedPhrases = [...newWords, ...phrases];
      localStorage.setItem('phrases', JSON.stringify(updatedPhrases));

      return updatedPhrases;
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);

export const addPhrase = createAsyncThunk('phrase/create', async (data, { rejectWithValue }) => {
  try {
    const phrase = await fbStore.collection('phrases').add({
      ...data,
      createdAt: new Date().toISOString(),
    });
    const res = await phrase.get();
    return {
      id: phrase.id,
      ...res.data(),
    };
  } catch (err) {
    return rejectWithValue(err);
  }
});

export const updatePhrase = createAsyncThunk('phrase/update', async (data, { rejectWithValue }) => {
  try {
    await fbStore.collection('phrases').doc(data.id).set(data, { merge: true });
    return data.id;
  } catch (err) {
    return rejectWithValue(err);
  }
});

export const removePhrase = createAsyncThunk(
  'phrase/remove',
  async (phraseId, { rejectWithValue }) => {
    try {
      await fbStore.collection('phrases').doc(phraseId).delete();
      return phraseId;
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);
